/* Lightweight SPA SEO helpers. */
const ORIGIN = "https://airlinesairports.com";

/* Per-page SEO: title, meta description, canonical and JSON-LD (master plan §31/33). */
export function setSeo({ title, description, canonical, jsonLd }) {
  if (title) document.title = title;
  if (description) {
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement("meta"); m.setAttribute("name", "description"); document.head.appendChild(m); }
    m.setAttribute("content", description);
  }
  if (canonical) {
    let l = document.querySelector('link[rel="canonical"]');
    if (!l) { l = document.createElement("link"); l.setAttribute("rel", "canonical"); document.head.appendChild(l); }
    l.setAttribute("href", canonical.startsWith("http") ? canonical : ORIGIN + canonical);
  }
  let s = document.getElementById("seo-jsonld");
  if (jsonLd) {
    if (!s) { s = document.createElement("script"); s.type = "application/ld+json"; s.id = "seo-jsonld"; document.head.appendChild(s); }
    s.textContent = JSON.stringify(jsonLd);
  } else if (s) {
    s.remove();
  }
}


/* Toggle a robots noindex meta for thin/auto-generated pages (Feb-2026 site
   review): pages without substantial original content should not be indexed.
   Call setNoindex(false) in the effect cleanup so navigation resets it. */
export function setNoindex(on) {
  let m = document.querySelector('meta[name="robots"][data-dynamic="1"]');
  if (on) {
    if (!m) {
      m = document.createElement("meta");
      m.setAttribute("name", "robots");
      m.setAttribute("data-dynamic", "1");
      document.head.appendChild(m);
    }
    m.setAttribute("content", "noindex, follow");
  } else if (m) {
    m.remove();
  }
}
